export default {
  "finance.title": "Finance & Settlements",
  "finance.subtitle": "Track revenue, dues and settlement requests",
  "finance.requestSettlement": "Request settlement",
  "finance.backToHome": "Back to home",
  "finance.demoNote": "This is a preview with demo data.",

  "finance.tab.revenue": "Revenue summary",
  "finance.tab.dues": "Outstanding dues",
  "finance.tab.settlements": "Settlement log",

  "finance.period.today": "Today",
  "finance.period.week": "Week",
  "finance.period.month": "Month",
  "finance.period.label": "Period",

  "finance.card.direct": "Direct order revenue",
  "finance.card.directHint": "Value of completed orders in the selected period.",
  "finance.card.deliveryFees": "Delivery fees transferred to the laundry",
  "finance.card.deliveryFeesHint": "Fees of tasks executed by the laundry's own sub-drivers.",
  "finance.card.total": "Total revenue",
  "finance.card.totalHint": "Direct order revenue plus the transferred delivery fees.",

  "finance.details.title": "Commission & payable details per order",
  "finance.details.col.order": "Order no.",
  "finance.details.col.finalTotal": "Final order value",
  "finance.details.col.commissionRate": "Commission rate",
  "finance.details.col.commissionAmount": "Commission amount",
  "finance.details.col.deliveryFee": "Transferred delivery fee",
  "finance.details.col.net": "Net payable",
  "finance.details.viewOrder": "View order",
  "finance.details.debtBadge": "Customer debt",
  "finance.details.note": "The laundry dues are calculated on the final order value and are not affected by a recorded customer debt.",
  "finance.details.empty": "No revenue recorded for this period",
  "finance.details.emptyDesc": "No revenue was recorded within the selected period.",
  "finance.details.error": "Could not load the revenue summary",

  "finance.none": "None",

  "finance.outstanding.title": "Outstanding dues",
  "finance.outstanding.balanceLabel": "Unsettled outstanding balance",
  "finance.outstanding.note": "The accumulated unsettled balance is independent from the today / week / month selection.",
  "finance.outstanding.breakdown": "Breakdown components",
  "finance.outstanding.orderComponent": "Order dues",
  "finance.outstanding.packageComponent": "Package dues",
  "finance.outstanding.packagePending": "No approved finance data for package entitlement yet, so only the clear order dues are shown.",
  "finance.outstanding.request": "Request settlement",
  "finance.outstanding.empty": "No unsettled dues",
  "finance.outstanding.emptyDesc": "There is no settleable balance right now.",
  "finance.outstanding.error": "Could not load outstanding dues",

  "finance.req.title": "Request settlement",
  "finance.req.amountLabel": "Approved total outstanding amount",
  "finance.req.note": "The settlement request will be sent to the administration for processing and transfer to the laundry bank account.",
  "finance.req.readonly": "The amount is shown for review from the system data and cannot be edited.",
  "finance.req.confirm": "Confirm settlement request",
  "finance.req.cancel": "Cancel",
  "finance.req.loading": "Refreshing the outstanding amount…",
  "finance.req.noAmount": "There is no settleable outstanding amount right now.",
  "finance.req.error": "Could not send the settlement request, please try again.",
  "finance.req.toast": "Settlement request sent",

  "finance.set.title": "Settlement log",
  "finance.set.col.requestedAt": "Request date",
  "finance.set.col.processedAt": "Processing date",
  "finance.set.col.amount": "Amount",
  "finance.set.col.status": "Status",
  "finance.set.col.reason": "Rejection reason",
  "finance.set.notProcessed": "Not processed yet",
  "finance.set.view": "Settlement details",
  "finance.set.empty": "No settlement requests yet",
  "finance.set.emptyDesc": "Once a settlement request is submitted it will appear here with its status.",
  "finance.set.error": "Could not load the settlement log",
  "finance.set.detailsTitle": "Settlement details",
  "finance.set.id": "Settlement no.",
  "finance.set.amount": "Amount",

  "finance.setDetail.back": "Back to settlement log",
  "finance.setDetail.notFound": "Settlement not found",
  "finance.setDetail.notFoundBack": "Back to settlement log",
  "finance.setDetail.error": "Could not load the settlement details",
  "finance.setDetail.infoTitle": "Settlement details",
  "finance.setDetail.requestedAt": "Request date",
  "finance.setDetail.receiptTitle": "Transfer receipt",
  "finance.setDetail.receiptAlt": "Bank transfer receipt image",
  "finance.setDetail.receiptNote": "The bank transfer receipt image as provided by the administration.",
  "finance.setDetail.receiptPending": "The transfer receipt will appear here once processing is complete.",
  "finance.setDetail.receiptNone": "No transfer receipt was attached to this settlement.",
  "finance.setDetail.download": "Download receipt image",
  "finance.setDetail.downloading": "Downloading…",
  "finance.setDetail.downloadStarted": "Receipt image download started",
  "finance.setDetail.downloadStartedDesc": "Keep the image handy for future reference.",
  "finance.setDetail.downloadError": "Could not download the receipt image",
  "finance.setDetail.receiptViewFull": "View full size",
  "finance.setDetail.receiptZoomHint": "Click the image to view it full size before downloading.",

  "finance.status.processing": "Processing",
  "finance.status.transferred": "Transferred",
  "finance.status.rejected": "Rejected"
};